import { Stack } from "@chakra-ui/react"
import React, { PropsWithChildren } from "react"

export const Footer = ({ children }: PropsWithChildren) => {
  const registerFooter = (el: HTMLDivElement) => {
    if (!el) return

    let parent: HTMLDivElement

    const resize = () => {
      parent ??= el.closest("[data-navigation-menu]") as HTMLDivElement
      if (!parent) return

      const height = el.offsetHeight
      parent.style.setProperty("--navigation-menu-footer-height", `${height}px`)
    }

    resize()

    const resizeObserver = new ResizeObserver(resize)
    resizeObserver.observe(el)

    // TODO: once we're on React 19
    // return () => {
    //   resizeObserver.disconnect()
    // }
  }

  return (
    <Stack
      ref={registerFooter}
      p={4}
      gap={3}
      clipPath="inset(-1rem 0 0 0)"
      position={{ base: "sticky", sm: "fixed" }}
      bottom={0}
      left={0}
      w={{ base: "100vw", sm: "var(--navigation-menu-width)" }}
      maxW="100vw"
      sx={{
        '[data-scrollable="true"] ~ &': {
          boxShadow: "0 0 0 1px var(--chakra-colors-ds-border-default)",
        },
      }}
    >
      {children}
    </Stack>
  )
}
